import { fetchStorageFile } from 'hooks/StoreFiles';
import React from 'react';
import styled from 'styled-components';
import StyledGlobal from '../../PlanoAnual2025.styled';
import AdEbook, { AdEbookEnum } from 'pages/ebooks/components/AdEbook';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { Image } from 'antd';

const Styled = {
    Container: styled.div<{ img: string }>`
        height: 680px;
        width: 100%;
        background-image: url(${props => props.img});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        gap: 100px;
        width: 40%;

        @media screen and (max-width: 1220px) {
            width: 60%;
        }
        @media screen and (max-width: 670px) {
            width: 100%;
        }
    `,

    Body: styled.div`
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 80px;
        font-weight: 600;
        @media screen and (max-width: 670px) {
            padding: 20px;
        }
    `,

    TitleBlack: styled.h1`
        color: #000000;
        font-weight: bold;
        font-family: 'Barlow', sans-serif;
        font-size: 32px;
    `,
};

const CapaPlanoAnual = () => {
    const isMax500px = IsCustomMaxWidth(500);

    return (
        <div style={{ backgroundColor: '#eae8e6' }}>
            <Styled.Container img={fetchStorageFile('anexo_storage_files_2027340517109049176.webp_2025-11-18-1763484294892.webp')}>
                {/* Adicionar o conteúdo da capa do Plano Anual aqui */}
                <Styled.Body>
                    <Styled.Content>
                        <h1>MINISTÉRIO DA CULTURA APRESENTA O PROJETO PLANO ANUAL INSTITUTO AYRTON SENNA</h1>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
                            <StyledGlobal.Title blue fontSize="52px">
                                Plano Anual <br />
                                Instituto Ayrton Senna
                            </StyledGlobal.Title>
                            <StyledGlobal.Title fontSize="32px" maxFontSize="28px">
                                Relatório Final 2025
                            </StyledGlobal.Title>
                        </div>
                    </Styled.Content>
                </Styled.Body>

                <AdEbook type={AdEbookEnum.SMALL} styles={{ position: 'relative', left: isMax500px ? '20px' : '80px' }} />
            </Styled.Container>
            <Image
                width={'100%'}
                src={fetchStorageFile('anexo_storage_files_9877646194582851674.jpg_2025-11-21-1763746153941.jpg')}
                alt=""
                style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center', borderRadius: 0 }}
                preview={{
                    style: {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    },
                }}
            />
        </div>
    );
};

export default CapaPlanoAnual;
